import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpService } from '@services/http.service';
import { Observable } from 'rxjs';
import { Attribute } from '@models/device';

@Injectable({
  providedIn: 'root',
})
export class AttributeService extends HttpService {
  readonly DEVICES_API = `${environment.apiUrl}/devices`;

  saveAttributes(deviceId: string, attribute: Attribute[]): Observable<any> {
    const options = this.createHeaders();
    return this.post(`${this.DEVICES_API}/${deviceId}/sensors/attributes`, attribute, options);
  }

}
